import { render, staticRenderFns } from "./AdvHomePart3.vue?vue&type=template&id=0d084a90&scoped=true&"
import script from "./AdvHomePart3.vue?vue&type=script&lang=js&"
export * from "./AdvHomePart3.vue?vue&type=script&lang=js&"
import style0 from "./AdvHomePart3.vue?vue&type=style&index=0&id=0d084a90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d084a90",
  null
  
)

export default component.exports